import React, { useState, useContext } from 'react'
import {
  Grid,
  Typography,
  TextField,
  Select,
  FormControl,
  MenuItem
} from '@material-ui/core'
import { COUNTRY_NAMES_BY_CODE, ISO_3166_COUNTRIES } from './../../../../constants'
import { useTranslation } from 'react-i18next'
import StripeElements from './../../../../steps/stripe'
import { Context } from '../../../../Store'

export const CardPaymentType = () => {
  const [cardHolderName, setCardHolderName] = useState('')
  const [cardHolderEmail, setCardHolderEmail] = useState('')
  const [cardHolderAddress, setCardHolderAddress] = useState('')
  const [cardHolderCity, setCardHolderCity] = useState('')
  const [cardHolderZip, setCardHolderZip] = useState('')
  const [cardHolderCountry, setCardHolderCountry] = useState('')
  const [_, dispatch] = useContext(Context)
  const { t } = useTranslation()

  const onChangeCardHolderName = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_NAME', payload: e.target.value })
    setCardHolderName(e.target.value)
  }

  const onChangeCardHolderEmail = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_EMAIL', payload: e.target.value })
    setCardHolderEmail(e.target.value)
  }

  const onChangeCardHolderAddress = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_ADDRESS', payload: e.target.value })
    setCardHolderAddress(e.target.value)
  }

  const onChangeCardHolderCity = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_CITY', payload: e.target.value })
    setCardHolderCity(e.target.value)
  }

  const onChangeCardHolderZip = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_ZIP', payload: e.target.value })
    setCardHolderZip(e.target.value)
  }

  const onChangeCardHolderCountry = (e) => {
    dispatch({ type: 'SET_CARD_HOLDER_COUNTRY', payload: e.target.value })
    setCardHolderCountry(e.target.value)
  }
  
  return (<>
    <StripeElements />
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.paymentInfo.cardHolderName')}</Typography>
      <TextField
        name="card_holder_name"
        type="text"
        fullWidth
        variant="outlined"
        value={cardHolderName}
        onChange={onChangeCardHolderName}
      />
    </Grid>
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.paymentInfo.cardHolderEmail')}</Typography>
      <TextField
        name="card_holder_email"
        type="text"
        fullWidth
        variant="outlined"
        value={cardHolderEmail}
        onChange={onChangeCardHolderEmail}
      />
    </Grid>
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.paymentInfo.cardHolderAddress')}</Typography>
      <TextField
        name="card_holder_address"
        type="text"
        fullWidth
        variant="outlined"
        value={cardHolderAddress}
        onChange={onChangeCardHolderAddress}
      />
    </Grid>
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.paymentInfo.cardHolderCity')}</Typography>
      <TextField
        name="card_holder_city"
        type="text"
        fullWidth
        variant="outlined"
        value={cardHolderCity}
        onChange={onChangeCardHolderCity}
      />
    </Grid>
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.paymentInfo.cardHolderZip')}</Typography>
      <TextField
        name="card_holder_zip"
        type="text"
        fullWidth
        variant="outlined"
        value={cardHolderZip}
        onChange={onChangeCardHolderZip}
      />
    </Grid>
    <Grid item xs={12} lg={11}>
      <FormControl fullWidth variant="outlined">
        <Typography variant="body1">{t('booking.paymentInfo.cardHolderCountry')}</Typography>
          <Select
            name="card_holder_country"
            value={cardHolderCountry}
            onChange={onChangeCardHolderCountry}
          >
            {ISO_3166_COUNTRIES.map((value) => (
              <MenuItem key={value} value={value}>
                {value} - {COUNTRY_NAMES_BY_CODE[value]}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
    </Grid>
  </>)
}